import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'form',
		'selectInput',
	]

	connect() {
		this.updateForm()
	}

	updateForm() {
		const selectedOption = this.selectInputTarget.options[this.selectInputTarget.selectedIndex] 
		const formAction = selectedOption.dataset.formAction
		const formMethod = selectedOption.dataset.formMethod || 'post'

		this.formTarget.action = formAction
		this.formTarget.method = formMethod
	}
}

